import shareReferBundled from "assets/images/referral/share-refer.png";
import shareAiBundled from "assets/images/referral/share-ai.png";
import posterAiBundled from "assets/images/poster/poster-ai.png";
import posterBoomBundled from "assets/images/poster/poster-boom.png";
import posterBoomGifBundled from "assets/images/poster/poster-boom.gif";
import posterBoomShareBundled from "assets/images/poster/poster-boom-share.png";
import posterPositionBundled from "assets/images/poster/poster-position.png";
import { publicAssetUrl } from "@/utils/publicSvgUrl";

/** next/webpack 静态资源：兼容 string | { src } | { default } */
export function resolveWebpackAssetUrl(asset) {
  if (asset == null) return "";
  if (typeof asset === "string") return asset;
  if (typeof asset === "object") {
    if (typeof asset.src === "string") return asset.src;
    if (typeof asset.default === "string") return asset.default;
    if (asset.default?.src) return asset.default.src;
  }
  return String(asset);
}

/**
 * 海报底图：优先同源 /poster-assets（WebView 无跨域/CORS 问题），webpack 哈希作回退
 * public 与 src/assets 各保留一份，构建后路径稳定
 */
export const REFERRAL_POSTER_ASSETS = {
  refer: {
    src: "/poster-assets/share-refer.png",
    file: "share-refer.png",
    bundled: resolveWebpackAssetUrl(shareReferBundled),
  },
  ai: {
    src: "/poster-assets/share-ai.png",
    file: "share-ai.png",
    bundled: resolveWebpackAssetUrl(shareAiBundled),
  },
  /** AI 跟单策略/订单分享海报底图 */
  aicopy: {
    src: "/poster-assets/poster-ai.png",
    file: "poster-ai.png",
    bundled: resolveWebpackAssetUrl(posterAiBundled),
  },
  position: {
    src: "/poster-assets/poster-position.png",
    file: "poster-position.png",
    bundled: resolveWebpackAssetUrl(posterPositionBundled),
  },
  /** AI 跟单爆点弹窗底图（弹窗展示用，静态回退） */
  boom: {
    src: "/poster-assets/poster-boom.png",
    file: "poster-boom.png",
    bundled: resolveWebpackAssetUrl(posterBoomBundled),
  },
  /** AI 跟单爆点弹窗动效（GIF） */
  boomGif: {
    src: "/poster-assets/poster-boom.gif",
    file: "poster-boom.gif",
    bundled: resolveWebpackAssetUrl(posterBoomGifBundled),
  },
  /** AI 跟单爆点分享海报底图（Share 抽屉/弹窗用） */
  boomShare: {
    src: "/poster-assets/poster-boom-share.png",
    file: "poster-boom-share.png",
    bundled: resolveWebpackAssetUrl(posterBoomShareBundled),
  },
};

/** @param {"refer"|"ai"|"aicopy"|"position"|"boom"|"boomGif"|"boomShare"} variant */
export function getReferralPosterDisplayUrl(variant) {
  const item = REFERRAL_POSTER_ASSETS[variant];
  if (!item) return "";
  // 生产 CDN：静态文件在 {NEXT_PUBLIC_cdn}/public/poster-assets/…（与 publicAssetUrl / AiLab GIF 一致）
  return publicAssetUrl(`poster-assets/${item.file}`);
}

/** @param {"refer"|"ai"|"aicopy"|"position"|"boom"|"boomShare"} variant */
export function getPosterDisplayUrl(variant) {
  return getReferralPosterDisplayUrl(variant);
}

/**
 * Canvas 合成：同源 fetch 优先，再回退 webpack/CDN 打包路径
 * @param {"refer"|"ai"|"aicopy"|"position"|"boom"|"boomShare"|"aicopyBoom"|"aicopyOrders"} variant
 */
export function getReferralPosterCanvasUrls(variant) {
  const key =
    variant === "aicopyOrders"
      ? "aicopy"
      : variant === "aicopyBoom"
        ? "boomShare"
        : variant;
  const item = REFERRAL_POSTER_ASSETS[key];
  if (!item) return [];
  return [publicAssetUrl(`poster-assets/${item.file}`), item.bundled].filter(Boolean);
}

let displayPreloadPromise = null;

/**
 * 预加载展示用海报（不写 Canvas 缓存，仅预热浏览器 HTTP 缓存）
 * @returns {Promise<void>}
 */
export function preloadReferralPosterImages() {
  if (typeof window === "undefined") return Promise.resolve();

  if (displayPreloadPromise) return displayPreloadPromise;

  const urls = Object.values(REFERRAL_POSTER_ASSETS)
    .map((item) => publicAssetUrl(`poster-assets/${item.file}`))
    .filter(Boolean);

  displayPreloadPromise = Promise.all(
    urls.map(
      (src) =>
        new Promise((resolve) => {
          const img = new Image();
          img.decoding = "async";
          img.onload = () => resolve();
          img.onerror = () => resolve();
          img.src = src;
        })
    )
  ).then(() => {});

  return displayPreloadPromise;
}
